import InputFeedbackWhite from './InputFeedbackWhite';

export default InputFeedbackWhite;
